import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Route guard that requires the user to have AT LEAST ONE of the given roles.
 * Assumes the AuthContext has already loaded (use inside AdminRoute).
 * Bounces to /admin (which redirects appropriately for each role) on mismatch.
 */
export default function RoleRoute({ roles, children }) {
  const { user } = useAuth();
  const allowed = user?.roles?.some(r => roles.includes(r));
  if (!allowed) {
    return <Navigate to="/admin" replace />;
  }
  return children;
}
